exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stadium-fields__top-bar {\n  margin-bottom: 24px;\n}\n.stadium-holiday__add-button {\n  margin-bottom: 16px;\n}\n.stadium-boosts__new-list {\n  background-color: #fffbe6;\n  padding: 8px;\n  margin-bottom: 16px;\n}\n", ""]);

// exports
